/**
 * Initialize Screenshot Slider blocks using a CSS marquee animation.
 * Duplicates slides until the track is wide enough for a seamless infinite loop,
 * then sets --marquee-width so the CSS animation knows how far to translate.
 */
document.querySelectorAll( '.b-screenshot-slider' ).forEach( ( block ) => {

	const container = block.querySelector( '.b-screenshot-slider__slider-con' );
	const track = container?.querySelector( '.b-screenshot-slider__track' );
	if ( ! container || ! track ) {

		return;

	}

	const originalItems = Array.from( track.children );
	if ( ! originalItems.length ) {

		return;

	}

	let lastWidth = 0;

	/**
	 *
	 */
	const setup = () => {

		const containerWidth = container.offsetWidth;

		if ( containerWidth === lastWidth ) {

			return;

		}
		lastWidth = containerWidth;

		track.innerHTML = '';
		originalItems.forEach( ( item ) => {

			track.appendChild( item );

		} );

		let trackWidth = track.scrollWidth;

		while ( trackWidth < containerWidth * 2 ) {

			originalItems.forEach( ( item ) => {

				track.appendChild( item.cloneNode( true ) );

			} );
			trackWidth = track.scrollWidth;

		}

		track.style.setProperty( '--marquee-width', `${ trackWidth / 2 }px` );

	};

	setup();

	const observer = new ResizeObserver( () => {

		setup();

	} );

	observer.observe( container );

} );
